var render, staticRenderFns
import script from "./SubscriptionChartBar.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionChartBar.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionChartBar.vue?vue&type=style&index=0&id=0a48d974&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a48d974",
  null
  
)

export default component.exports